'use client';
import React, { useEffect, useState } from 'react';
import Image from "next/image"
import Link from "next/link"
import UserProfile from './contentcards/UserProfile'
import BreadCrumbs from './breadcrumbs/BreadCrumbs';
import { KeenIcon } from '../keenicons';
import { fetchSettingsData } from '../../../../lib/action';
import { toast } from 'sonner';
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { setSettings } from '@/lib/slices/customerSlice'
import { ScreenLoader } from '../loaders/ScreenLoader';
import { usePathname } from 'next/navigation';

function formatTitle(pathname: string): string {
    if (!pathname || pathname === '/') return '';

    const segments = pathname
        .split('/')
        .filter(Boolean) 
        .map(seg =>
            seg
                .replace(/_/g, ' ') 
                .replace(/\b\w/g, c => c.toUpperCase()) 
        );

    if (segments.length === 1) return `| ${segments[0]}`;
    if (segments.length >= 2) {
        const [section, page] = segments;
        return `| ${section} - ${page}`;
    }

    return `| ${segments.join(' - ')}`;
}

export default function TopHeader() {
    const [isScrolled, setIsScrolled] = useState(false);
    const intl = useIntl();
    const { settings, settingsLoading, settingserror } = useSelector((state: any) => state.customer)
    const dispatch = useDispatch();
    const pathname = usePathname();

    const toggleSidebar = () => {
        window.dispatchEvent(new CustomEvent('toggle-sidebar'));
    };

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (!settings || !pathname) return;

        const siteTitle = settings?.options?.siteTitle || 'T3elements';
        const formattedPath = formatTitle(pathname);
        const fullTitle = `${siteTitle} ${formattedPath}`;

        if (document.title !== fullTitle) {
            document.title = fullTitle;
        }
    }, [settings, pathname]);


    useEffect(() => {
        const fetchStatistics = async () => {
            try {
                const _resStatistics = await fetchSettingsData();
                dispatch(setSettings({
                    settings: _resStatistics
                }));
                if (settingserror) toast.error(settingserror || intl.formatMessage({ id: 'SOMETHING_WENT_WRONG' }));
            } catch (err: any) {
                toast.error(err?.message || err?.msg || err?.err || err?.error || intl.formatMessage({ id: 'MEMBERSHIP.ERROR' }));
            }
        };
        fetchStatistics();
    }, [dispatch]);

    useEffect(() => {
        if (settingserror !== null && settingserror !== undefined) {
            toast.error(settingserror || intl.formatMessage({ id: 'SOMETHING_WENT_WRONG' }));
        }
    }, [settingserror]);

    if (settingsLoading) {
        return <ScreenLoader />;
    }


    return (
        <>
            <header
                className={`header fixed top-0 z-10 start-0 end-0 flex items-stretch shrink-0 bg-[--tw-page-bg] dark:bg-[--tw-page-bg-dark] ${isScrolled ? 'shadow-sm' : ''}`} >
                <div
                    className="container-fixed flex justify-between items-stretch lg:gap-4"
                    id="header_container"
                >
                    {/* Mobile Logo */}
                    <div className="flex gap-1 lg:hidden items-center -ms-1">
                        <Link className="shrink-0" href="/">
                            <Image
                                className="max-h-[25px] w-full"
                                src={
                                    settings?.options?.logo?.original
                                        ? (process.env.NEXT_PUBLIC_IMAGE_BASE_URL || '') + settings.options.favicon.original
                                        : "/assets/media/app/mini-logo.png"
                                }
                                alt="Mini Logo"
                                width={100}
                                height={25}
                            />
                        </Link>
                        <div className="flex items-center">
                            <button
                                className="btn btn-icon btn-light btn-clear btn-sm"
                                data-drawer-toggle="#sidebar"
                                onClick={toggleSidebar}
                            >
                                <i className="ki-filled ki-menu"></i>
                            </button>
                        </div>
                    </div>
                    <BreadCrumbs
                        separator={<KeenIcon icon="right" className="text-gray-500 text-3xs" />}
                    />
                    <UserProfile />
                </div>
            </header></>
    )
}
